import Swiper from "swiper";
import { Pagination, Navigation } from "swiper/modules";
require("fslightbox");

const certificateCategories = document.querySelectorAll(
  ".certificate-categories__category"
);

if (certificateCategories) {
  certificateCategories.forEach((category, index) => {
    const slider = category.querySelector(`.certificate-slider-${index}`);
    const swiper = new Swiper(slider, {
      modules: [Navigation, Pagination],

      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 20,
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: `.swiper-pagination-${index}`,
      },
      navigation: {
        nextEl: `.next-btn-${index}`,
        prevEl: `.prev-btn-${index}`,
      },
    });
  });
}
